import Vue from 'vue'

export const ScenarioEventBus = new Vue()

export const ScenarioEventBusType = {
    CREATE_INTENT: 'CREATE_INTENT',
    CREATE_ENTITY: 'CREATE_ENTITY',
    CREATE_SAMPLE: 'CREATE_SAMPLE',
    CREATE_KEYWORD: 'CREATE_KEYWORD',
    CREATE_DICTIONARY: 'CREATE_DICTIONARY',
    SELECT_NODE: 'SELECT_NODE',
    IMPORT_FILE: 'IMPORT_FILE',
    MANAGE_USER: 'MANAGE_USER'
}
